import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gifter-detail',
  templateUrl: './gifter-detail.component.html',
  styleUrls: ['./gifter-detail.component.css'],
  imports: [CommonModule],
})
export class GifterDetailComponent {
  @Input() selectedGifter: any;
  @Input() selectedGifterInfo: any;
  @Input() formatTime!: (time: string) => string;

  @Output() close = new EventEmitter<void>();
}
